@let pdfTimesheetData = userTimeSheet$ | async;
<wilson-working-time-section-wrapper
  [title]="'page.working_time.pdf_timesheet.title' | translate"
>
  <ion-col class="pe-3">
    <wilson-worktime-pdf-timesheet-card
      [userTimeSheetFileAccessInput]="
        $safeNavigationMigration(pdfTimesheetData?.fileAccess)
      "
      [fileName]="$safeNavigationMigration(pdfTimesheetData?.fileName)"
      [isLoading]="isTimeSheetLoadingSignal()"
    />
  </ion-col>
</wilson-working-time-section-wrapper>
